import React, { useState, useEffect } from 'react';
import { Spinner, Card, Form, Button, InputGroup } from 'react-bootstrap';
import axios from 'axios';
import { FaSearch, FaTimes } from 'react-icons/fa';
import getAPI from '../../service/getAPI';
import InquiryList from './inquiry';
import RecourierList from './RecourierList';
import RefundList from './RefundList';
import ResolvedList from './Resolved';
import AttemptedList from './AttemptedList';
import AssignList from './AssignList';

const navItems = [
  { id: 'inquiry', label: 'Query', count: 0 },
  { id: 'attempted', label: 'Attempted', count: 0 },
  { id: 'refund', label: 'Refund', count: 0 },
  { id: 'recourier', label: 'Re-courier', count: 0 },
  { id: 'assigned', label: 'Assigned', count: 0 },
  { id: 'resolved', label: 'Resolved', count: 0 }
];

const AllTabs = () => {
  const { master } = getAPI();
  const [activeTab, setActiveTab] = useState('inquiry');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const fetchAllData = async (page = 1, limit = 10, tab = activeTab) => {
    setLoading(true);
    setError('');
    try {
      const endpoints = {
        inquiry: master.InquiryList,
        attempted: master.getAttemptInquiryList,
        refund: master.RefundList,
        recourier: master.RecourierList,
        assigned: master.assignInquiryList,
        resolved: master.ResolveList
      };

      // For the attempted tab, we'll use the AttemptedList component directly
      if (tab === 'attempted') {
        return { data: [] }; // The AttemptedList component will handle its own data fetching
      }

      const response = await axios.post(endpoints[tab] || endpoints.inquiry, {
        page,
        limit,
        search,
        from_date: fromDate,
        to_date: toDate,
      });

      return response.data;
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch data');
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // Debounce search to avoid too many API calls
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchAllData(1, 10, activeTab);
    }, 500);

    return () => clearTimeout(timer);
  }, [activeTab, search, fromDate, toDate]);

  const renderTabContent = () => {
    const commonProps = {
      fetchInquiries: fetchAllData,
      loading,
      error,
      search,
      setSearch,
      fromDate,
      setFromDate,
      toDate,
      setToDate
    };
// search={search} setSearch={setSearch}
    switch (activeTab) {
      case 'inquiry':
        return <InquiryList {...commonProps} search={search} setSearch={setSearch} />;
      case 'attempted':
        return <AttemptedList {...commonProps} search={search} setSearch={setSearch} />;
      case 'refund':
        return <RefundList {...commonProps} search={search} setSearch={setSearch} />;
      case 'recourier':
        return <RecourierList {...commonProps} search={search} setSearch={setSearch} />;
      case 'assigned':
        return <AssignList {...commonProps} search={search} setSearch={setSearch} />;
      case 'resolved':
        return <ResolvedList {...commonProps} search={search} setSearch={setSearch} />;
      default:
        return <InquiryList {...commonProps} search={search} setSearch={setSearch} />;
    }
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  // Clear search
  const clearSearch = () => {
    setSearch('');
  };

  return (
    <main id="main" className="main">
      <div className="pagetitle">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h1>All Query</h1>
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="/">Masters</a></li>
                <li className="breadcrumb-item active">All Query</li>
              </ol>
            </nav>
          </div>
          
          {/* Global Search */}
          <div className="d-flex align-items-center" style={{ width: '400px' }}>
            <InputGroup>
              <InputGroup.Text className="bg-white">
                <FaSearch className="text-muted" />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search across all queries..."
                value={search}
                onChange={handleSearchChange}
                className="border-start-0"
              />
              {search && (
                <Button 
                  variant="outline-secondary" 
                  onClick={clearSearch}
                  className="border-start-0"
                >
                  <FaTimes />
                </Button>
              )}
            </InputGroup>
          </div>
        </div>
      </div>
        {/* Header */}
        {/* <div className="d-flex justify-content-between align-items-center mb-4"> */}
        {/* <h4 className="m-0">All Query</h4> */}
        {/* <div className="d-flex">
          <div className="input-group me-2" style={{ width: '250px' }}>
            <input 
              type="text" 
              className="form-control" 
              placeholder="Search..." 
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button className="btn btn-outline-secondary" type="button">
              <FaSearch />
            </button>
          </div>
          <button className="btn btn-outline-secondary me-2">
            <FaFilter className="me-1" /> Filter
          </button>
          <button className="btn btn-primary">
            + Add New
          </button>
        </div> */}
        {/* </div> */}


        {/* Content */}
        <Card>
          <Card.Header className="d-flex justify-content-between align-items-center">
            {/* Tabs */}
            <div className="d-flex">
              {navItems.map((item) => (
                <div
                  key={item.id}
                  className={`px-4 py-2 me-2 cursor-pointer ${activeTab === item.id ? 'border-bottom border-primary border-3 text-primary' : 'text-muted'}`}
                  onClick={() => setActiveTab(item.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="d-flex align-items-center">
                    <span className="me-2">{item.label}</span>
                    {item.count > 0 && (
                      <span className="badge bg-primary rounded-pill">{item.count}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </Card.Header>
          <Card.Body className="p-0">
            {loading ? (
              <div className="text-center p-5">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            ) : error ? (
              <div className="alert alert-danger m-3" role="alert">
                {error}
              </div>
            ) : (
              <div className="p-3">
                {renderTabContent()}
              </div>
            )}
          </Card.Body>
        </Card>
    </main>
  );
};

export default AllTabs;